$(document).ready(function ($) {
  var key = 'cookies_confirmed';
  var cookies_confirmed = localStorage.getItem(key);
  if (!cookies_confirmed) {
    $('#cookies-info-modal').popup('show');
  }
  $('#cookies-info-modal-close-btn').click(function () {
    $('#cookies-info-modal').popup('hide');
  });
  $('#cookies-info-modal-accept-btn').click(function () {
    $('#cookies-info-modal').popup('hide');
    localStorage.setItem(key, '1');
  });

  if ($(window).width() <= 992 && $('.header--mobile').length) {
    new Waypoint.Sticky({
      element: $('.header--mobile'),
      stuckClass: 'fixed'
    });
    $($('.sticky-wrapper')[1]).detach().appendTo('body');
  }

  $('.language_change_container').click(function (event) {
    $('.language_change_options_container').toggleClass('opened');
    event.stopPropagation();
  });

  $('html').click(function (event) {
    $('.language_change_options_container').removeClass('opened');
  });

  $('#open_search').click(function () {
    $('#search_icon').hide();
    $('#search_container').show();
  });

  var $latestTabs = $('.latest');

  if ($latestTabs.length) {
    if ($(window).width() < 768) {
      var tab_product_slider1 = new Swiper('#tab-1 .swiper-container', {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '#tab-1 .swiper-button-next',
          prevEl: '#tab-1 .swiper-button-prev'
        }
      });

      var tab_product_slider2 = new Swiper('#tab-2 .swiper-container', {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '#tab-2 .swiper-button-next',
          prevEl: '#tab-2 .swiper-button-prev'
        }
      });
    }

    $latestTabs.find('.tabs-nav a').click(function (event) {
      event.preventDefault();
      $(this).parent().addClass('active');
      $(this).parent().siblings().removeClass('active');
      var tab = $(this).attr('href');
      $latestTabs.find('.tab').not(tab).css('display', 'none');
      $(tab).fadeIn();

      if ($(window).width() < 768) {
        tab_product_slider1.update();
        tab_product_slider2.update();
      }
    });
  }

  // Megamenu
  if ($(window).width() > 767) {
    $('.header__nav ul li').mouseenter(function () {
      $(this).find('.sub-nav').css('float', 'none');
      $(this).find('.sub-nav').stop().slideDown(200);
    });

    $('.header__nav ul li').mouseleave(function () {
      $(this).find('.sub-nav').stop(false, false).delay(1000).slideUp(200);
    });
  }

  $('.mobile_nav, .mobile_search').show();

  // Open mobile menu when click on hamburger
  $('.header--mobile .hamb')
    .not('.top-close')
    .click(function (evt) {
      evt.preventDefault();
      $(this).toggleClass('open');

      if ($('.mobile_nav').hasClass('opened')) {
        $('.mobile_nav').removeClass('opened');
      } else {
        $('.mobile_nav').addClass('opened');
      }
    });

  $('.header--mobile .hamb.top-close').click(function (evt) {
    evt.preventDefault();
    $('.hamb.open').not('.top-close').toggleClass('open');

    if ($('.mobile_nav').hasClass('opened')) {
      $('.mobile_nav').removeClass('opened');
    } else {
      $('.mobile_nav').addClass('opened');
    }
  });

  $('.mobile_nav > ul > li > a.dropdown').click(function (e) {
    e.preventDefault();
    $('.mobile_nav > ul > li > .subnav').slideToggle();
    $(this).text($(this).text() === '-' ? '+' : '-');
    // $('.mobile_nav > ul > li > .subnav').removeClass('opened');
    // $(this).parent().find('>ul').addClass('opened');
  });

  $('.mobile_nav > ul > li > .subnav > li a.dropdown').click(function (e) {
    e.preventDefault();
    $('.mobile_nav > ul > li > .subnav > li > .subnav').removeClass('opened');
    $(this).parent().find('>ul').addClass('opened');
  });

  $('.mobile_nav > ul > li > .subnav > li > a.back').click(function (e) {
    e.preventDefault();
    $(this).parent().parent().removeClass('opened');
  });

  $('.mobile_nav > ul > li > .subnav > li > .subnav > li > a.back').click(function (e) {
    e.preventDefault();
    $(this).parent().parent().removeClass('opened');
  });

  $('.header__search input').keyup(function () {
    var value = $(this).val();
    if (value.length > 0) {
      $('.search_results').fadeIn(400);
    } else {
      $('.search_results').fadeOut(400);
    }
  });

  $('.open_search').click(function (e) {
    e.preventDefault();

    $(this).parent().toggleClass('opened');
  });

  $('.close_search').click(function (e) {
    e.preventDefault();

    $('.search').toggleClass('opened');
  });

  if ($('.open_filters').length) {
    $('.open_filters').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('active');

      if ($(this).hasClass('active')) {
        $('.open_sorting').removeClass('active');
        $('.mobile_controls .sort').hide();
        $('.mobile_controls .filters').slideDown(300);
      } else {
        $('.mobile_controls .filters').slideUp(300);
      }
    });
  }

  var $cartTabs = $('.cart__info');

  if ($cartTabs.length) {
    $cartTabs.find('.tabs-nav a').click(function (event) {
      event.preventDefault();
      $(this).parent().addClass('active');
      $(this).parent().siblings().removeClass('active');
      var tab = $(this).attr('href');
      $cartTabs.find('.tab').not(tab).css('display', 'none');
      $(tab).fadeIn();
    });
  }

  if ($('.open_sorting').length) {
    $('.open_sorting').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('active');

      if ($(this).hasClass('active')) {
        $('.open_filters').removeClass('active');
        $('.mobile_controls .filters').hide();
        $('.mobile_controls .sort').slideDown(300);
      } else {
        $('.mobile_controls .sort').slideUp(300);
      }
    });
  }

  // $('.header__controls .minicart > a').click(function (e) {
  //   e.preventDefault();
  //   $(this).parent().find('.minicart_object').toggleClass('opened');
  //
  //   if($(this).parent().find('.minicart_object').hasClass('opened')) {
  //     $(this).parent().find('.minicart_object').fadeOut(300);
  //   } else {
  //     $(this).parent().find('.minicart_object').fadeIn(300);
  //   }
  // });

  if ($('.cart__information').length) {
    $('.cart__information .item a').click(function (e) {
      e.preventDefault();
      $('.cart__information .item a').not(this).parent().removeClass('opened');
      $('.cart__information .item a').not(this).parent().find('.content').slideUp(300);
      if ($(this).parent().hasClass('opened')) {
        $(this).parent().removeClass('opened');
        $(this).parent().find('.content').slideUp(300);
      } else {
        $(this).parent().addClass('opened');
        $(this).parent().find('.content').slideDown(300);
      }
    });
  }

  if ($('.faq').length) {
    $('.faq .item a').click(function (e) {
      e.preventDefault();
      $('.faq .item a').not(this).parent().removeClass('opened');
      $('.faq .item a').not(this).parent().find('.content').slideUp(300);
      if ($(this).parent().hasClass('opened')) {
        $(this).parent().removeClass('opened');
        $(this).parent().find('.content').slideUp(300);
      } else {
        $(this).parent().addClass('opened');
        $(this).parent().find('.content').slideDown(300);
      }
    });
  }

  if ($('.products_slider#slider_one').length) {
    var swiper_one = new Swiper('.products_slider#slider_one .slider-wrap > .swiper-container', {
      slidesPerView: 4,
      navigation: {
        nextEl: '.products_slider#slider_one .slider-wrap > .swiper-button-next',
        prevEl: '.products_slider#slider_one .slider-wrap > .swiper-button-prev'
      },
      breakpoints: {
        992: {
          slidesPerView: 3
        },
        767: {
          slidesPerView: 1
        }
      }
    });

    var swiper_two = new Swiper('.products_slider#slider_two .slider-wrap > .swiper-container', {
      slidesPerView: 4,
      navigation: {
        nextEl: '.products_slider#slider_two .slider-wrap > .swiper-button-next',
        prevEl: '.products_slider#slider_two .slider-wrap > .swiper-button-prev'
      },
      breakpoints: {
        992: {
          slidesPerView: 3
        },
        767: {
          slidesPerView: 1
        }
      }
    });
  }

  // Sorting Types list
  if ($('.sorting  .sort').length) {
    $('.sorting  .sort > a').click(function (e) {
      e.preventDefault();
      if ($(this).parent().find('ul').hasClass('opened')) {
        $(this).parent().find('ul').fadeOut(600);
        $(this).parent().find('ul').removeClass('opened');
        $(this).parent().removeClass('opened');
      } else {
        $(this).parent().find('ul').fadeIn(600);
        $(this).parent().find('ul').addClass('opened');
        $(this).parent().addClass('opened');
      }
    });
  }

  // Sorting Types list
  $('.sorting__list .count > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent().find('ul').hasClass('opened')) {
      $(this).parent().find('ul').fadeOut(600);
      $(this).parent().find('ul').removeClass('opened');
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().find('ul').fadeIn(600);
      $(this).parent().find('ul').addClass('opened');
      $(this).parent().addClass('opened');
    }
  });

  // Sorting Show list
  $('.sorting__view > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent().find('ul').hasClass('opened')) {
      $(this).parent().find('ul').fadeOut(600);
      $(this).parent().find('ul').removeClass('opened');
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().find('ul').fadeIn(600);
      $(this).parent().find('ul').addClass('opened');
      $(this).parent().addClass('opened');
    }
  });

  // Sorting Pages list
  $('.more-pages > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent().find('ul').hasClass('opened')) {
      $(this).parent().find('ul').fadeOut(600);
      $(this).parent().find('ul').removeClass('opened');
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().find('ul').fadeIn(600);
      //$('.more-pages ul .inner').jScrollPane();
      $(this).parent().find('ul').addClass('opened');
      $(this).parent().addClass('opened');
    }
  });

  // Sorting types list
  $('.sorting__types > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent().find('ul').hasClass('opened')) {
      $(this).parent().find('ul').fadeOut(600);
      $(this).parent().find('ul').removeClass('opened');
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().find('ul').fadeIn(600);
      $(this).parent().find('ul').addClass('opened');
      $(this).parent().addClass('opened');
    }
  });

  // Open mobile menu when click on hamburger
  $('.checkout_page .hamb').click(function () {
    $(this).toggleClass('open');

    if ($('.header').hasClass('opened')) {
      $('.header').slideUp(500).removeClass('opened');
      $('.checkout_header').removeClass('parent_active');
    } else {
      $('.header').addClass('opened').slideDown(500);
      $('.checkout_header').addClass('parent_active');
    }
  });

  $('a[href*="#"]:not([href="#"]):not(.open_tabs_link)').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate(
          {
            scrollTop: target.offset().top - 80
          },
          1000
        );
        return false;
      }
    }
  });

  var $ordersTable = $('.profile__orders'),
    $ordersTableItem = $ordersTable.find('.item');
  if ($ordersTable.length) {
    $ordersTableItem.find('a.expand').click(function (e) {
      e.preventDefault();

      if ($(this).parent().parent().hasClass('opened')) {
        $(this).parent().parent().removeClass('opened');
        $(this).parent().parent().find('.order-details').slideUp(300);
      } else {
        $('.profile__orders .item').removeClass('opened');
        $('.order-details').slideUp(300);
        $(this).parent().parent().addClass('opened');
        $(this).parent().parent().find('.order-details').slideDown(300);
      }
    });
  }

  var $returnsTable = $('.returns_table'),
    $returnsTableItem = $returnsTable.find('.item');
  if ($returnsTable.length) {
    $returnsTableItem.find('.expand a').click(function (e) {
      e.preventDefault();

      if ($(this).parent().parent().parent().hasClass('opened')) {
        $(this).parent().parent().parent().removeClass('opened');
        $(this).parent().parent().parent().find('.return_details').slideUp(300);
        $(this).text('zwróć');
      } else {
        $('.returns_table .item').removeClass('opened');
        $('.return_details').slideUp(300);
        $(this).text('Anuluj');
        $(this).parent().parent().parent().addClass('opened');
        $(this).parent().parent().parent().find('.return_details').slideDown(300);
      }
    });
  }

  $('.open_search').click(function (e) {
    e.preventDefault();
    $('#inputSearchText').focus();
    $('.header--mobile_bottom .search form').addClass('opened');
  });

  $('.close_search').click(function (e) {
    e.preventDefault();
    $('.header--mobile_bottom .search form').removeClass('opened');
  });

  $('.filters_open').click(function (e) {
    e.preventDefault();
    $('.filters').addClass('opened');
  });

  $('.close_filters').click(function (e) {
    e.preventDefault();
    $('.filters').removeClass('opened');
  });

  $('.sorting_open').click(function (e) {
    e.preventDefault();
    $('.mobile_sorting').addClass('opened');
  });

  $('.sorting_close').click(function (e) {
    e.preventDefault();
    $('.mobile_sorting').removeClass('opened');
  });

  if ($('.hero .swiper-container').length) {
    var hero_swiper = new Swiper('.hero .swiper-container', {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.hero .swiper-button-next',
        prevEl: '.hero .swiper-button-prev'
      },
      pagination: {
        el: '.hero .swiper-pagination',
        clickable: true
      }
    });
  }

  var $returnsTable = $('.profile__returns'),
    $returnsTableItem = $returnsTable.find('.item');
  if ($returnsTable.length) {
    $returnsTableItem.find('a.expand').click(function (e) {
      e.preventDefault();

      if ($(this).parent().parent().hasClass('opened')) {
        $(this).parent().parent().removeClass('opened');
        $(this).parent().parent().find('.return-details').slideUp(300);
      } else {
        $('.profile__returns .item').removeClass('opened');
        $('.return-details').slideUp(300);
        $(this).parent().parent().addClass('opened');
        $(this).parent().parent().find('.return-details').slideDown(300);
      }
    });
  }

  function handleScroll(el) {
    if ($(el).scrollTop() > 100) {
      $('a.goup').fadeIn();
    } else {
      $('a.goup').fadeOut();
    }
  }

  if ($(document).width() <= 767) {
    $(document).scroll(handleScroll.bind(this, this));
  } else {
    $('body').scroll(handleScroll.bind(this, 'body'));
  }
  // Scroll to top when click on Scroll to top button
  $('a.goup').click(function (e) {
    e.preventDefault();
    jQuery('html, body').animate(
      {
        scrollTop: 0
      },
      600
    );
  });
});
